import type {EditOfferTemplateNoteFormPayload} from "./edit-offer-template-note.schema";
import {editOfferTemplateNote} from "@project/sdk/sales";
import {EditOfferTemplateNoteResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {offerTemplateKeys, offerTemplateMutationKeys} from "../../../../../offerTemplate-keys";
import {editOfferTemplateNoteFormSchema} from "./edit-offer-template-note.schema";

export function editOfferTemplateNoteMutationOptions(id: string, noteId: number) {
  return mutationOptions({
    mutationKey: offerTemplateMutationKeys.editOfferTemplateNote,
    mutationFn: async (payload: EditOfferTemplateNoteFormPayload) =>
      EditOfferTemplateNoteResponse.parse(
        await editOfferTemplateNote(id, noteId, editOfferTemplateNoteFormSchema.parse(payload)),
      ),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: offerTemplateKeys.detail(id)}),
        client.invalidateQueries({queryKey: offerTemplateKeys.lists()}),
      ]);
    },
  });
}
